import { Navigate, useLocation, useParams } from 'react-router-dom'

// <Navigate> doesn't interpolate `:params` into `to`, so read them here.
export function LegacyTickerRedirect({ tab }: { tab: string }) {
  const { tickerId = '' } = useParams()
  const { search } = useLocation()
  return <Navigate to={`/research/${encodeURIComponent(tickerId)}/${tab}${search}`} replace />
}
